import styles from './bannerCard.module.css';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { FiArrowLeft } from "react-icons/fi";


export default function BannerCard() {

  const navigateTo = useNavigate();

  const cards = [
    { id: 1, to: '/protocols', src: "/assets/images/bannerCard/protocol.png", title: 'پروتکل', desc: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و' },
    { id: 2, to: '/discounts', src: "/assets/images/bannerCard/discount.png", title: 'فروش ویژه', desc: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و' },
    { id: 3, to: '/services', src: "/assets/images/bannerCard/service.png", title: 'خدمات ما', desc: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و' },
  ];


  return (
    <div className={`${styles.bannerCard_container} d-flex flex-column flex-sm-row justify-content-center gap-3 gap-sm-2 gap-md-5 position-relative z-1`}>
      {cards.map(({ id, src, title, to }, index) =>
        <motion.div
          className={`${styles.bannerCard} d-flex flex-sm-column justify-content-center align-items-center gap-3 gap-md-4 px-3 py-4 bgWhite user-select-none`}
          key={id}
          initial={{ opacity: 0, y: '0' }}
          whileInView={{ opacity: 1, y: '-50%' }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: (index) * 0.1 }}
          // onClick={() => window.innerWidth < 576 && navigateTo(to)}
          onClick={() => window.innerWidth < 576 && title !== 'خدمات ما' && navigateTo(to)}
        >
          <img src={src} alt={title} className={styles.image} loading='lazy'/>
          <strong className='h5 text-center textDarkBlue m-0'>{title}</strong>
          <Button className='d-none d-sm-block w-75' variant='outlined' color='primary' onClick={() => navigateTo(to)}
            disabled={title === 'خدمات ما'}
            >
            مشاهده
            <FiArrowLeft className='fs-6 me-1' />
          </Button>
        </motion.div>
      )}
    </div>
  )
}